import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pg-form-section, grit-form-section',
  templateUrl: './pg-form-section.component.html',
  styleUrls: ['./pg-form-section.component.scss'],
})
export class PgFormSectionComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
